import request from "@/utils/request";

// 平台补贴管理-补贴列表
export function subsidyList(params) {
    return request({
        url: `/marketing/plm/subsidy/ops/subsidy/page`,
        method: "get",
        params,
    });
}

// 平台补贴管理-新建补贴
export function subsidyAdd(data) {
    return request({
        url: `/marketing/plm/subsidy/ops/add/subsidy/info`,
        method: "post",
        data,
    });
}


// 平台补贴管理-编辑、更新活动
export function subsidyUpdate(data) {
    return request({
        url: `/marketing/plm/subsidy/update/plm/subsidy`,
        method: "PUT",
        data,
    });
}

// 平台补贴管理-查看平台活动详情
export function subsidyDetails(id) {
    return request({
        url: `/marketing/plm/subsidy/ops/subsidy/info/${id}`,
        method: "get",
    });
}

//平台补贴管理-停止活动
export function subsidyStartOrStop(id) {
    return request({
        url: `/marketing/plm/subsidy/stop/plm/subsidy/${id}`,
        method: "PUT",
    });
}

//平台补贴管理-删除活动
export function subsidyDelete(id) {
    return request({
        url: `/marketing/plm/subsidy/delete/subsidy?id=${id}`,
        method: "delete",
    });
}

//平台补贴管理-查询单个平台补贴活动的商品列表
export function subsidyGoodsInfo(params) {
    return request({
        url: `/marketing/plm/subsidy/get/subsidy/goods/info`,
        method: "get",
        params
    });
}

// 新增补贴规则
export function subsidyRulesAdd(data) {
    return request({
        url: `/marketing/subsidy/plmsubsidyrule/addPlmSubsidyRule`,
        method: "post",
        data,
    });
}

// 批量移除参与活动的商品
export function deleteSubsidyGoodsList(data) {
    return request({
        url: `/marketing/plm/subsidy/delete/subsidy/goods/list`,
        method: "post",
        data,
    });
}

//单个移除参与活动的商品
export function subsidyGoodsDelete(id) {
    return request({
        url: `/marketing/plm/subsidy/delete/subsidy/goods/${id}`,
        method: "delete",
    });
}

//平台补贴管理-查询所有活动商品列表
export function getAllSubsidyGoodsInfo(params) {
    return request({
        url: `/marketing/plm/subsidy/get/all/subsidy/goods/info`,
        method: "get",
        params
    });
}

